/** The member and invitation visibility choices in an organization's address. */
export class OrganizationFilters {
	#parameters: URLSearchParams;

	constructor(parameters: URLSearchParams) {
		this.#parameters = new URLSearchParams(parameters);
	}

	/** Whether removed members were explicitly requested. */
	get removed(): boolean { return this.#parameters.get('members-removed') === '1'; }

	/** Whether closed invitations were explicitly requested. */
	get closed(): boolean { return this.#parameters.get('invitations-closed') === '1'; }

	/** Changes one choice while retaining the tab and every other list's context. */
	set(name: 'removed' | 'closed', enabled: boolean): URLSearchParams {
		const next = new URLSearchParams(this.#parameters);
		const key = name === 'removed' ? 'members-removed' : 'invitations-closed';
		if (enabled) next.set(key, '1');
		else next.delete(key);
		if (name === 'removed') next.delete('members-page');
		return next;
	}
}
